var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgjsline1393(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 183,
    viewBox: "0 0 2 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0.588837 0.0516968V182.445",
    stroke: "#B6B6B6",
    strokeWidth: 0.977381,
    strokeDasharray: "2.93 2.93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgjsline1393);
export default __webpack_public_path__ + "static/media/svgjsline1393.f7fcc3949516cc3b0624ba8e5d72f9fd.svg";
export { ForwardRef as ReactComponent };